/* tslint:disable */
/* eslint-disable */
export enum UserRemoteRoles {
  RemoteConsignor = 'remote_consignor',
  RemoteConsignee = 'remote_consignee',
  RemoteCarrier = 'remote_carrier'
}
